export enum FormTypeClient {
	CR = "coverage-request",
	IR = "initial-response",
	CB = "continuous-benefit",
	PI = "primary-intervention",
	SI = "subsequent-intervention",
	DN = "discontinuation-note",
}

export enum UserSubscription {
	Free = "Free",
	Premium = "Premium",
}

export const DeletedUserEmail = "deleted.user@lyfegen.com";
